import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Input, RadioButton, TextArea } from '../../../../components'
import problema from '../../detalheplano/blocks/problema'
import acoespropostas from '../../detalheplano/blocks/acoespropostas'
import { gravarAcoesBlacklist } from '../redux/aprovarplanoplanActions'
import './problemaacao.scss'

const Problema = problema
const Acoespropostas = acoespropostas

const Problemaacao = ({ data, nls, value, onChange }) => {
  const dispatch = useDispatch()
  const { projetoId } = useSelector(state => state.pdcaState.pdcaBaseState)

  const problemaData = data?.problema || null
  const acao = data?.acao || null
  const planoIdAtual = data?.plano?.pdca_plano_id || data?.plano?.id || 0

  const acoes = Array.isArray(acao?.acoes) ? acao.acoes : []

  const [acaoBlacklistSelecionada, setAcaoBlacklistSelecionada] = useState({})
  const [motivoBlacklist, setMotivoBlacklist] = useState('')
  const [acoesOcultasBlacklist, setAcoesOcultasBlacklist] = useState([])
  const [submittingBlacklist, setSubmittingBlacklist] = useState(false)

  const tipoAcaoSelecionado = value?.tipoAcao || 'padrao'
  const comentarioAcao = value?.comentarioAcao || ''
  const tituloPersonalizado = value?.tituloPersonalizado || ''
  const descricaoPersonalizada = value?.descricaoPersonalizada || ''
  const deadline = value?.deadline || ''

  const tipoAcaoOptions = useMemo(() => ([
    { value: 'padrao', label: nls.standardActionOption },
    { value: 'personalizada', label: nls.customActionOption }
  ]), [nls.standardActionOption, nls.customActionOption])

  const acoesRecomendadas = useMemo(
    () => acoes.filter(item => Number(item?.ehrecomendada) === 1),
    [acoes]
  )

  const todasRecomendadas = acoes.length > 0 && acoes.every(item => Number(item?.ehrecomendada) === 1)
  const precisaEscolherAcaoPadrao = acoes.length > 0 && !todasRecomendadas

  const opcoesAcoesPadrao = useMemo(() => (
    acoes.map(item => ({
      value: item?.acaoid,
      label: item?.titulo || '',
      ehrecomendada: Number(item?.ehrecomendada) === 1
    }))
  ), [acoes])

  const acaoPadraoSelecionada = useMemo(() => {
    return opcoesAcoesPadrao.find(item => item?.value === value?.acaoId) || {}
  }, [opcoesAcoesPadrao, value?.acaoId])

  const opcoesBlacklist = useMemo(() => (
    acoes
      .filter(item => !acoesOcultasBlacklist.includes(item?.acaoid))
      .map(item => ({
        value: item?.acaoid,
        label: item?.titulo || '',
        raw: item
      }))
  ), [acoes, acoesOcultasBlacklist])

  const exibirBlocoBlacklist = opcoesBlacklist.length > 0

  useEffect(() => {
    if (tipoAcaoSelecionado !== 'padrao') {
      return
    }

    if (todasRecomendadas && acoesRecomendadas.length > 0 && !value?.acaoId) {
      onChange({
        ...value,
        tipoAcao: 'padrao',
        acaoId: acoesRecomendadas[0]?.acaoid || null,
        todasRecomendadas: true
      })
      return
    }

    if (precisaEscolherAcaoPadrao && opcoesAcoesPadrao.length > 0 && !value?.acaoId) {
      onChange({
        ...value,
        tipoAcao: 'padrao',
        acaoId: opcoesAcoesPadrao[0]?.value || null,
        todasRecomendadas: false
      })
    }
  }, [
    tipoAcaoSelecionado,
    todasRecomendadas,
    acoesRecomendadas,
    precisaEscolherAcaoPadrao,
    opcoesAcoesPadrao,
    value,
    onChange
  ])

  const handleSelecionarTipoAcao = e => {
    const novoTipo = e?.value?.value || 'padrao'

    onChange({
      ...value,
      tipoAcao: novoTipo,
      acaoId:
        novoTipo === 'padrao'
          ? (todasRecomendadas
            ? acoesRecomendadas[0]?.acaoid || null
            : opcoesAcoesPadrao[0]?.value || null)
          : null,
      comentarioAcao: novoTipo === 'padrao' ? comentarioAcao : '',
      tituloPersonalizado: novoTipo === 'personalizada' ? tituloPersonalizado : '',
      descricaoPersonalizada: novoTipo === 'personalizada' ? descricaoPersonalizada : '',
      todasRecomendadas: novoTipo === 'padrao' ? todasRecomendadas : false
    })
  }

  const handleSelecionarAcaoPadrao = e => {
    onChange({
      ...value,
      acaoId: e?.value?.value || null,
      todasRecomendadas: false
    })
  }

  const handleChangeComentario = inputValue => {
    const texto =
      typeof inputValue === 'string'
        ? inputValue
        : inputValue?.target?.value !== undefined
          ? inputValue.target.value
          : inputValue?.value !== undefined
            ? inputValue.value
            : ''

    onChange({
      ...value,
      comentarioAcao: texto
    })
  }

  const handleChangeDescricao = inputValue => {
    const texto =
      typeof inputValue === 'string'
        ? inputValue
        : inputValue?.target?.value !== undefined
          ? inputValue.target.value
          : inputValue?.value !== undefined
            ? inputValue.value
            : ''

    onChange({
      ...value,
      descricaoPersonalizada: texto
    })
  }

  const handleSelecionarAcaoBlacklist = e => {
    const opcaoSelecionada = e?.value || {}

    setAcaoBlacklistSelecionada(opcaoSelecionada)
    setMotivoBlacklist('')
  }

  const handleCancelarBlacklist = () => {
    setAcaoBlacklistSelecionada({})
    setMotivoBlacklist('')
  }

  const handleConfirmarBlacklist = async () => {
    if (!acaoBlacklistSelecionada?.value || !projetoId || !planoIdAtual) {
      return
    }

    setSubmittingBlacklist(true)

    const result = await dispatch(gravarAcoesBlacklist({
      projetoId,
      acaoId: acaoBlacklistSelecionada.value,
      planoId: planoIdAtual,
      motivo: motivoBlacklist || ''
    }))

    setSubmittingBlacklist(false)

    if (result?.ok) {
      setAcoesOcultasBlacklist(prev => [...prev, acaoBlacklistSelecionada.value])
      setAcaoBlacklistSelecionada({})
      setMotivoBlacklist('')
    }
  }

  const hoje = new Date()
  const ano = hoje.getFullYear()
  const mes = String(hoje.getMonth() + 1).padStart(2, '0')
  const dia = String(hoje.getDate()).padStart(2, '0')
  const hojeInput = `${ano}-${mes}-${dia}`

  return (
    <div className='aprovarplanoplan-problemaacao'>
      <div className='aprovarplanoplan-problemaacao__title'>
        {nls.blockProblemActionTitle}
      </div>

      <div className='aprovarplanoplan-problemaacao__content'>
        <div className='aprovarplanoplan-problemaacao__subsection'>
          <Problema
            problema={problemaData}
            nls={nls}
          />
        </div>

        <div className='aprovarplanoplan-problemaacao__subsection'>
          <Acoespropostas
            acao={acao}
            nls={nls}
          />
        </div>

        {exibirBlocoBlacklist && (
          <div className='aprovarplanoplan-problemaacao__subsection'>
            <div className='aprovarplanoplan-problemaacao__blacklist-title'>
              {nls.blacklistTitle}
            </div>

            <div className='aprovarplanoplan-problemaacao__helper'>
              {nls.blacklistHelperText}
            </div>

            <div className='aprovarplanoplan-problemaacao__blacklist-options'>
              {opcoesBlacklist.map(item => (
                <div
                  key={`acao-blacklist-${item.value}`}
                  className='aprovarplanoplan-problemaacao__blacklist-item'
                >
                  <RadioButton
                    name='acaoBlacklistEscolhida'
                    label=''
                    options={[item]}
                    checked={acaoBlacklistSelecionada}
                    action={handleSelecionarAcaoBlacklist}
                    optionLabel='label'
                    optionValue='value'
                  />

                  {acaoBlacklistSelecionada?.value === item.value && (
                    <div className='aprovarplanoplan-problemaacao__blacklist-panel'>
                      <div className='aprovarplanoplan-problemaacao__field'>
                        <label className='aprovarplanoplan-problemaacao__label'>
                          {nls.blacklistReasonLabel}
                        </label>
                        <Input
                          name='motivoBlacklist'
                          action={e => setMotivoBlacklist(e?.value ?? e?.target?.value ?? '')}
                          value={motivoBlacklist}
                          placeholder={nls.blacklistReasonPlaceholder}
                        />
                      </div>

                      <div className='aprovarplanoplan-problemaacao__blacklist-actions'>
                        <Button
  data-cy='pdca-plan-blacklist-confirm'
  data-cy-effect='write'
  color='primary'
  onClick={handleConfirmarBlacklist}
  disabled={submittingBlacklist}
>
                          {nls.confirm}
                        </Button>

                        <Button
  data-cy='pdca-plan-blacklist-cancel'
  data-cy-effect='read'
  color='default'
  onClick={handleCancelarBlacklist}
  disabled={submittingBlacklist}
>
                          {nls.cancel}
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className='aprovarplanoplan-problemaacao__subsection'>
          <RadioButton
            name='tipoAcaoPlano'
            label={nls.actionChoiceLabel}
            options={tipoAcaoOptions}
            checked={tipoAcaoOptions.find(item => item.value === tipoAcaoSelecionado) || tipoAcaoOptions[0]}
            action={handleSelecionarTipoAcao}
            optionLabel='label'
            optionValue='value'
          />
        </div>

        {tipoAcaoSelecionado === 'padrao' && (
          <div className='aprovarplanoplan-problemaacao__subsection'>
            {todasRecomendadas ? (
              <>
                <div className='aprovarplanoplan-problemaacao__helper'>
                  {nls.allRecommendedMessage}
                </div>

                <div className='aprovarplanoplan-problemaacao__action-list'>
                  {acoesRecomendadas.map(item => (
                    <div
                      key={`acao-recomendada-${item?.acaoid}`}
                      className='aprovarplanoplan-problemaacao__action-card'
                    >
                      {item?.titulo}
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className='aprovarplanoplan-problemaacao__helper'>
                  {nls.chooseStandardActionMessage}
                </div>

                <div className='aprovarplanoplan-problemaacao__action-options'>
                  {opcoesAcoesPadrao.map(item => (
                    <div
                      key={`acao-padrao-${item.value}`}
                      className={`aprovarplanoplan-problemaacao__radio-row ${item?.ehrecomendada ? 'aprovarplanoplan-problemaacao__radio-row--recommended' : ''}`}
                    >
                      <RadioButton
                        name='acaoPadraoEscolhida'
                        label=''
                        options={[item]}
                        checked={acaoPadraoSelecionada}
                        action={handleSelecionarAcaoPadrao}
                        optionLabel='label'
                        optionValue='value'
                      />
                      {item?.ehrecomendada && (
                        <span className='aprovarplanoplan-problemaacao__recommended-tag'>
                          {nls.recommendedLabel}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}

            <div className='aprovarplanoplan-problemaacao__field'>
              <label className='aprovarplanoplan-problemaacao__label'>
                {nls.commentLabel}
              </label>
              <TextArea
                name='comentarioAcaoPadrao'
                value={comentarioAcao}
                action={handleChangeComentario}
              />
            </div>
          </div>
        )}

        {tipoAcaoSelecionado === 'personalizada' && (
          <div className='aprovarplanoplan-problemaacao__subsection'>
            <div className='aprovarplanoplan-problemaacao__field'>
              <Input
                name='tituloPersonalizado'
                action={e => onChange({
                  ...value,
                  tituloPersonalizado: e?.value ?? e?.target?.value ?? ''
                })}
                value={tituloPersonalizado}
                placeholder={nls.customTitlePlaceholder}
              />
            </div>

            <div className='aprovarplanoplan-problemaacao__field'>
              <label className='aprovarplanoplan-problemaacao__label'>
                {nls.customDescriptionLabel}
              </label>
              <TextArea
                name='descricaoPersonalizada'
                value={descricaoPersonalizada}
                action={handleChangeDescricao}
              />
            </div>
          </div>
        )}

        <div className='aprovarplanoplan-problemaacao__subsection'>
          <div className='aprovarplanoplan-problemaacao__field'>
            <label className='aprovarplanoplan-problemaacao__label'>
              {nls.deadlineLabel}
            </label>
            <input
              type='date'
              value={deadline}
              min={hojeInput}
              onChange={e => onChange({
                ...value,
                deadline: e.target.value
              })}
              className='aprovarplanoplan-problemaacao__date-input'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Problemaacao